import * as React from 'react';
import { useBookingWizardPricingCacheStore } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardPricingCacheStore';
import { getFrontendNavLinks } from '../../FrontendNavLinks';
import Navigation, { Orientation, ILink } from './Navigation';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import useDeviceDetect from 'Hooks/useDeviceDetect';
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useOrganisationStore } from 'Global/Organisations/OrganisationsStore';
import { store } from 'Models/Store';

export interface NavigationWrapperProps {
	className?: string;
}

function NavigationWrapper(props: NavigationWrapperProps) {
	const location = useLocation();
	const params = useParams();

	const orgStore = useOrganisationStore();
	const { isMobile, isIpad } = useDeviceDetect();
	const [links, setLinks] = useState<ILink[][]>([[]]);

	const wizardPricingCache = useBookingWizardPricingCacheStore();

	const { className } = props;

	// Read the user-state values explicitly so the effect re-runs when they change.
	// MobX `observer` re-renders the component when these are read in render, but
	// useEffect deps don't auto-track observables — without listing them here, modal
	// flows (voucher / parking / anytime ticket) that change the logged-in user
	// without changing the URL leave the nav showing the previous user's initials
	// and menu items. The booking wizard happens to navigate after guest login, so
	// location.pathname changing already triggered a refresh there.
	const userId = store.userId;
	const isGuestUser = store.userData?.isGuest;
	const userGroupNames = store.userGroups.map(g => g.name).join(',');

	useEffect(() => {
		setLinks(
			getFrontendNavLinks(
				location,
				isIpad,
				orgStore.organisations,
				orgStore.selectedOrganisation,
				Object.keys(wizardPricingCache.bookingPrices).filter(
					id => id !== '00000000-0000-0000-0000-000000000000',
				).length > 0,
			),
		);
	}, [
		isIpad,
		location.pathname,
		params,
		orgStore.selectedOrganisation,
		wizardPricingCache.bookingPrices,
		userId,
		isGuestUser,
		userGroupNames,
	]);

	return (
		<Navigation
			className={className}
			linkGroups={links}
			orientation={Orientation.HORIZONTAL}
			alwaysExpanded
			isMobile={isIpad}
		/>
	);
}

export default observer(NavigationWrapper);
